import React, { useEffect } from 'react';
import { drawCardContour, drawGuideRect } from '../../utils/canvas';
import styles from './CardOverlay.module.css';

const STATUS_TEXT = {
  'no-card': 'Position card within the frame',
  'card-detected': 'Move closer to the card',
  stable: 'Hold steady...',
  capturing: 'Capturing!',
};

const STATUS_STYLE = {
  'no-card': styles.noCard,
  'card-detected': styles.detected,
  stable: styles.stable,
  capturing: styles.capturing,
};

function getContourColor(status) {
  switch (status) {
    case 'stable':
    case 'capturing':
      return '#00ff88';
    case 'card-detected':
      return '#ffa500';
    default:
      return '#ffffff';
  }
}

export function CardOverlay({
  overlayRef,
  videoRef,
  corners,
  status,
  stableFrames,
  stabilityThreshold,
  showManualCapture,
  onManualCapture,
  currentSide = 'front',
}) {
  const sideLabel = currentSide === 'front' ? 'Take FRONT of card' : 'Take BACK of card';

  useEffect(() => {
    const canvas = overlayRef.current;
    const video = videoRef.current;
    if (!canvas || !video) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    if (!corners) {
      const dpr = window.devicePixelRatio || 1;
      canvas.width = canvas.clientWidth * dpr;
      canvas.height = canvas.clientHeight * dpr;
      ctx.scale(dpr, dpr);
      drawGuideRect(ctx, canvas.clientWidth, canvas.clientHeight, sideLabel);
      return;
    }

    canvas.width = video.videoWidth || canvas.clientWidth;
    canvas.height = video.videoHeight || canvas.clientHeight;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    drawCardContour(ctx, corners, getContourColor(status));

    if (status === 'stable' && stabilityThreshold > 0) {
      const progress = Math.min(stableFrames / stabilityThreshold, 1);
      const centerX = (corners[0].x + corners[2].x) / 2;
      const centerY = (corners[0].y + corners[2].y) / 2;

      ctx.strokeStyle = '#00ff88';
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.arc(centerX, centerY, 30, -Math.PI / 2, -Math.PI / 2 + progress * Math.PI * 2);
      ctx.stroke();
    }
  }, [overlayRef, videoRef, corners, status, stableFrames, stabilityThreshold, sideLabel]);

  return (
    <>
      {status !== 'no-card' && (
        <div className={`${styles.statusBar} ${STATUS_STYLE[status]}`}>
          {STATUS_TEXT[status]}
        </div>
      )}
      {showManualCapture && status !== 'capturing' && (
        <button
          className={styles.captureBtn}
          onClick={onManualCapture}
          aria-label="Capture photo"
        />
      )}
    </>
  );
}
